import { XyCustomEvent } from '@xyo-network/sdk-xyo-react-js';
class CoinEvents {
    addToCart() {
        return new XyCustomEvent('AddToCart');
    }
    purchase() {
        return new XyCustomEvent('Purchase');
    }
    initiateCheckout() {
        return new XyCustomEvent('InitiateCheckout');
    }
    contactInfoComplete() {
        return new XyCustomEvent('ContactInfoComplete');
    }
    addressInfoComplete() {
        return new XyCustomEvent('AddressInfoComplete');
    }
    paymentInfoComplete() {
        return new XyCustomEvent('PaymentInfoComplete');
    }
    transactionAttempted() {
        return new XyCustomEvent('TransactionAttempted');
    }
    transactionFailed() {
        return new XyCustomEvent('TransactionFailed');
    }
    transactionCompleted() {
        return new XyCustomEvent('TransactionCompleted');
    }
    trialStarted() {
        return new XyCustomEvent('TrialStarted');
    }
    upsellViewed() {
        return new XyCustomEvent('UpsellViewed');
    }
    upsellUnavailable() {
        return new XyCustomEvent('UpsellUnavailable');
    }
    upsellAccepted() {
        return new XyCustomEvent('UpsellAccepted');
    }
    upsellSucceeded() {
        return new XyCustomEvent('UpsellSucceeded');
    }
    upsellFailed() {
        return new XyCustomEvent('UpsellFailed');
    }
    testStarted() {
        return new XyCustomEvent('TestStarted');
    }
    userClick() {
        return new XyCustomEvent('UserClick');
    }
    viewContent() {
        return new XyCustomEvent('ViewContent');
    }
    funnelStarted() {
        return new XyCustomEvent('FunnelStarted');
    }
    emailCollected() {
        return new XyCustomEvent('EmailCollected');
    }
    accountCreated() {
        return new XyCustomEvent('AccountCreated');
    }
    shareCompleted() {
        return new XyCustomEvent('ShareCompleted');
    }
    funnelCompleted() {
        return new XyCustomEvent('FunnelCompleted');
    }
    buyticketsCompleted() {
        return new XyCustomEvent('BuyTicketsCompleted');
    }
    installCompleted() {
        return new XyCustomEvent('InstallCompleted');
    }
    offerRequested() {
        return new XyCustomEvent('OfferRequested');
    }
    feedbackScoreCollected() {
        return new XyCustomEvent('FeedbackScoreCollected');
    }
    feedbackSourceCollected() {
        return new XyCustomEvent('FeedbackSourceCollected');
    }
    goodFeedbackRequested() {
        return new XyCustomEvent('GoodFeedbackRequested');
    }
    badFeedbackRequested() {
        return new XyCustomEvent('BadFeedbackRequested');
    }
}
export default CoinEvents;
